module.exports = __webpack_public_path__ + "assets/img/Slice 164(6).7a2bbbe7.png";